/**
 * 单个门店
 */
import React, { FC, useState } from 'react'
import i18n from 'i18next'
import { Icon } from '@cps'
import { storeMobx } from '@mobxStore'
import { format } from '@dt/fe-utils'
import appMobx from '@mobx/app/app.mobx'
import { restaurantConfig, cartMobx } from 'restaurant'
import './index.scss'

interface IProps {
  /** 月购门店 bought 最近门店 near */
  type?: 'bought' | 'near';
  isDelvery?: boolean;
  /** 门店数据 */
  store?: IViewStore;
  /** 选择门店 */
  onSelectStore?(store?: IViewStore): void;
}

/** 时间字符串处理 */
const tommss = (time: number) => {
  const minutes = parseInt(String(time / 60))
  const seconds = time % 60
  const s = `${minutes ? i18n.t('common.minutes', { time: minutes }) : ''}${seconds ? i18n.t('common.seconds', { time: seconds }) : ''}`
  return s
}

const getNowDiff = (oldDiff: number, baseStamp: number, nowStamp: number) => {
  const diff = ((nowStamp - baseStamp) / 1000).toFixed()
  return parseInt(String(oldDiff - Number(diff)))
}

const StoreItem: FC<IProps> = ({ type, store, isDelvery, onSelectStore }) => {
  const [showStore, setShowStore] = useState([])
  if (!store) return null
  const storeSaleTime = format.toSaleTime(store.saleTime, bo === 'cn' ? '24' : '12')
  const disabled = Config.codeType === 'table' && store.storeId !== storeMobx.info.storeId
  const current = restaurantConfig.storeId === store.storeId
  /** 门店营业状态 */
  const getCountDownStatus = (store: IViewStore) => {
    const nowDiff = getNowDiff(
      store.countDownDiff,
      store.baseTimeStamp,
      appMobx.now
    )
    const canPreOrderTag =
      store.isMobileBookingOrder ? (
        <span className='pre-order-tag'>{i18n.t('store.booking')}</span>
      ) : null
    if (nowDiff > 0 && nowDiff < 1800) {
      return (
        <p className='store-count-down'>
          {canPreOrderTag}
          <span className='rest-tag'>
            {store.inSale
              ? i18n.t('store.closeBusiness', { time: tommss(nowDiff) })
              : i18n.t('store.beginBusiness', { time: tommss(nowDiff) })}
          </span>
        </p>
      )
    } else if (nowDiff === 0) {
      return null
    } else if (!store.inSale) {
      return (
        <p className='store-count-down'>
          {canPreOrderTag}
          <span className='rest-tag'>{i18n.t('store.resting')}</span>
        </p>
      )
    } else {
      return null
    }
  }
  /** 月购和最近 */
  const getTypeNode = () => !!type && <div className={`store-type ${type}`}><Icon name={type === 'bought' ? 'cart' : 'address'} />{i18n.t(`store.${type}`)} {store.distanceWithUnit}</div>
  return (
    <div
      className={`store-list-item${disabled ? ' disabled' : ''}${current ? ' current' : ''}`}
      key={store.storeId}
      onClick={() => onSelectStore(store)}
    >
      <div className='store-msg-wrap'>
        {getTypeNode()}
        <div className='store-name'>{store.storeName}</div>
        <div className='store-status'>
          {
            current && (
              <div className='current-store'>
                <i className='iconfont icon-daxuanzhong2x'></i>
                <span>
                  {i18n.t('store.curStore')}
                </span>
              </div>
            )
          }
          {
            store.boughtCnt ? (
              <div className='store-bought-cnt'>
                {i18n.t('store.boughtStoreByStore', { num: store.boughtCnt })}
              </div>
            ) : <></>
          }
          {getCountDownStatus(store)}
          {
            restaurantConfig.codeType === 'brand' && (cartMobx.info.eatType || Config.eatType) === 'delivery' && !store?.openSelfDelivery && (
              <div className='self-delivery'>
                {i18n.t('store.noSelfDelivery')}
              </div>
            )
          }
        </div>
        <div className='store-location'>
          <Icon name='location' />
          <span>{store.address}{store.addressDetails}</span>
        </div>
        <div className='store-eat-type'>
          <i className='iconfont icon-taocan' />
          {(store.sceneEatTypes || []).map((eattype, index) => (<span className='eat-tag' key={eattype + index}><small>{i18n.t(`menu.${eattype === 'togo' ? 'pickup' : eattype}`)}</small></span>))}
        </div>
        <div className={`business-time-list ${!showStore.includes(store.storeId) && (storeSaleTime.length > 1 || storeSaleTime[0].zhLength() > 20) ? 'hide-time' : ''}`}>
          <i className='iconfont icon-time2x' />
          <div>
            <div className='item-wrap'>
              {storeSaleTime.map((v, index: number) => <p key={index}>{v}</p>)}
            </div>
            {storeSaleTime.length > 1 || storeSaleTime[0].zhLength() > 25 ? (
              <span
                className='more-btn' onClick={(e) => {
                  e.stopPropagation()
                  showStore.includes(store.storeId) ? setShowStore(showStore.filter(v => v !== store.storeId)) : setShowStore([...showStore, store.storeId])
                }}
              >{showStore.includes(store.storeId) ? i18n.t('common.hide') : <i className='iconfont icon-zhankai2x'></i>}
              </span>
            ) : ''}
          </div>
        </div>
      </div>
      {!!store.distanceWithUnit && !type && (
        <div className='store-right'>
          <p className='store-distance'>
            {store.distanceWithUnit}
          </p>
          {/* <p className='store-go'>去下单</p> */}
        </div>
      )}
      {/* {getTypeNode()} */}
    </div>
  )
}

export default StoreItem
